module.exports = __webpack_public_path__ + "static/media/bronze_test_banner_en.8ada84d7.png";